"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));
var _iconModule = _interopRequireDefault(require("./icon.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ArcIcon(props) {
  var _size, _size2;
  var onClick = props.onClick,
    size = props.size,
    name = props.name,
    hover = props.hover,
    className = props.className;
  size = {
    height: (_size = size) !== null && _size !== void 0 && _size.height ? size.height : 16,
    width: (_size2 = size) !== null && _size2 !== void 0 && _size2.width ? size.width : 16
  };
  try {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(_iconModule["default"].wrapper, " ").concat(onClick || hover ? _iconModule["default"].pointer : "", "\n      ").concat(className ? className : '', " "),
      onClick: onClick && onClick
    }, /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
      src: "./images/".concat(name) + '.svg',
      width: size.width,
      height: size.height,
      title: name
    }));
  } catch (e) {
    var err = "Icon Error: ".concat(!name ? 'name is missing in prop' : e.message);
    return /*#__PURE__*/_react["default"].createElement("span", {
      title: err
    }, "icon error");
  }
}
var _default = ArcIcon;
exports["default"] = _default;